export class RequisitionPerformanceReportService {
    /*@ngInject*/
    constructor() {
    }
    getReportSections() {
        return [
            { sectionNumber: 0, isGraphLoading: true, isTableLoading: true, name: "Workflow Steps", table: {}, graph: {}, subSections: [] },
            { sectionNumber: 1, isGraphLoading: true, isTableLoading: true, name: "Job Matches Scores", table: {}, graph: {}, subSections: [] },
            { sectionNumber: 2, isGraphLoading: true, isTableLoading: true, name: "Tech Assessments Scores", table: {}, graph: {}, subSections: [] },
            { sectionNumber: 3, isGraphLoading: true, isTableLoading: true, name: "Release Reasons", table: {}, graph: {},
                subSections: [
                    { sectionNumber: 5, isGraphLoading: true, isTableLoading: true, name: "Other Release Reasons", table: {}, graph: {}, subSections: [] }
                ]
            },
            { sectionNumber: 4, isGraphLoading: true, isTableLoading: true, name: "Not Interested Reasons", table: {}, graph: {},
                subSections: [
                    { sectionNumber: 6, isGraphLoading: true, isTableLoading: true, name: "Other Not Interested Reasons", table: {}, graph: {}, subSections: [] }
                ]
            }
        ];
    }
    getReportPeriods() {
        return [
            {
                name: "This Week",
                displayName: "This Week"
            },
            {
                name: "Last Week",
                displayName: "Last Week"
            },
            {
                name: "This Month",
                displayName: "This Month"
            },
            {
                name: "Last Month",
                displayName: "Last Month"
            },
            {
                name: "Custom",
                displayName: "Custom (Max 90 days)"
            }
        ];
    }
    getMassagedReportData(fetchedData, viewReportBy, companyName) {
        let massagedTableData = this._getMassagedTableData(fetchedData, viewReportBy);
        let tableData = massagedTableData[0];
        tableData.withoutTotal = massagedTableData[1];
        tableData.withCorporateCandidates = massagedTableData[2];
        tableData.withoutTotalWithCorporateCandidates = massagedTableData[3];
        tableData.rawData = fetchedData.tableReport;
        let massagedGraphData = this._getMassagedGraphData(fetchedData, companyName, viewReportBy);
        let graphData = massagedGraphData[0];
        graphData.withCorporate = massagedGraphData[1];
        graphData.clientNameWithCountsForLabels = fetchedData.graphReport.workflowStepsGraphReport.candidates;
        graphData.withCorporate.clientNameWithCountsForLabels = fetchedData.graphReport.workflowStepsGraphReport.candidates;
        return {
            table: tableData,
            graph: graphData
        };
    }
    _getMassagedTableData(fetchedData, viewReportBy) {
        let fetchedTableData = {};
        let fetchedTableDataWithoutTotal = {};
        let fetchedTableWithCorporateCandidateData = {};
        let fetchedTableDataWithoutTotalAndWithCorporateCandidates = {};
        //All data
        fetchedTableData = {
            workflowSteps: fetchedData.tableReport.workflowStepTableReports.filter(entry => !entry.corporateSharedRequisitionReport),
            jobMatchesScores: fetchedData.tableReport.jobMatchesScoresTableReports.filter(entry => !entry.corporateSharedRequisitionReport),
            techAssessmentScores: fetchedData.tableReport.techAssessmentScoresReports.filter(entry => !entry.corporateSharedRequisitionReport),
            releaseReasons: fetchedData.tableReport.releaseReasonsReports.filter(entry => !entry.corporateSharedRequisitionReport),
            notInterestedReasons: fetchedData.tableReport.notInterestedReasonsReports.filter(entry => !entry.corporateSharedRequisitionReport),
            totalCountDetail: fetchedData.tableReport.totalCountDetail
        };
        this._setWorkflowStepsTableData(fetchedTableData);
        this._setTechAssessmentTableData(fetchedTableData);
        this._setReasonsTableData(fetchedTableData, fetchedData.topTenReleasedReasons, fetchedData.topTenNotInterestedReasons);
        this._setCandidatesTotalCount(fetchedTableData);
        //Data without totals
        fetchedTableDataWithoutTotal = {
            workflowSteps: fetchedData.tableReport.vendorOrClientOrBULevelTableReport.workflowStepVendorOrClientOrBULevelDetailDTOs.filter(entry => !entry.corporateSharedRequisitionReport),
            jobMatchesScores: fetchedData.tableReport.vendorOrClientOrBULevelTableReport.jobMatchesScoresVendorOrClientOrBULevelTableReportDTOs.filter(entry => !entry.corporateSharedRequisitionReport),
            techAssessmentScores: fetchedData.tableReport.vendorOrClientOrBULevelTableReport.taScoresVendorOrClientOrBULevelTableReportDTOs.filter(entry => !entry.corporateSharedRequisitionReport),
            releaseReasons: fetchedData.tableReport.vendorOrClientOrBULevelTableReport.releaseReasonsVendorOrClientOrBULevelTableReportDTOs.filter(entry => !entry.corporateSharedRequisitionReport),
            notInterestedReasons: fetchedData.tableReport.vendorOrClientOrBULevelTableReport.notInterestedVendorOrClientOrBULevelReasonsTableReportDTOs.filter(entry => !entry.corporateSharedRequisitionReport),
            totalCountDetail: fetchedData.tableReport.vendorOrClientOrBULevelTableReport.totalCountDetail
        };
        this._setWorkflowStepsTableData(fetchedTableDataWithoutTotal);
        this._setTechAssessmentTableData(fetchedTableDataWithoutTotal);
        this._setReasonsTableData(fetchedTableDataWithoutTotal, fetchedData.topTenReleasedReasons, fetchedData.topTenNotInterestedReasons);
        this._setCandidatesTotalCount(fetchedTableDataWithoutTotal);
        if (viewReportBy == 'vendor') {
            //All Data with corporateCandidates
            fetchedTableWithCorporateCandidateData = {
                workflowSteps: fetchedData.tableReport.workflowStepTableReports,
                jobMatchesScores: fetchedData.tableReport.jobMatchesScoresTableReports,
                techAssessmentScores: fetchedData.tableReport.techAssessmentScoresReports,
                releaseReasons: fetchedData.tableReport.releaseReasonsReports,
                notInterestedReasons: fetchedData.tableReport.notInterestedReasonsReports,
                totalCountDetail: fetchedData.tableReport.totalCountDetailIncludingCorporateSharedRequisitionReport
            };
            this._setWorkflowStepsTableData(fetchedTableWithCorporateCandidateData);
            this._setTechAssessmentTableData(fetchedTableWithCorporateCandidateData);
            this._setReasonsTableData(fetchedTableWithCorporateCandidateData, fetchedData.topTenReleasedReasons, fetchedData.topTenNotInterestedReasons);
            this._setCandidatesTotalCount(fetchedTableWithCorporateCandidateData);
            //Data without totals and with corporate candidates
            fetchedTableDataWithoutTotalAndWithCorporateCandidates = {
                workflowSteps: fetchedData.tableReport.vendorOrClientOrBULevelTableReport.workflowStepVendorOrClientOrBULevelDetailDTOs,
                jobMatchesScores: fetchedData.tableReport.vendorOrClientOrBULevelTableReport.jobMatchesScoresVendorOrClientOrBULevelTableReportDTOs,
                techAssessmentScores: fetchedData.tableReport.vendorOrClientOrBULevelTableReport.taScoresVendorOrClientOrBULevelTableReportDTOs,
                releaseReasons: fetchedData.tableReport.vendorOrClientOrBULevelTableReport.releaseReasonsVendorOrClientOrBULevelTableReportDTOs,
                notInterestedReasons: fetchedData.tableReport.vendorOrClientOrBULevelTableReport.notInterestedVendorOrClientOrBULevelReasonsTableReportDTOs,
                totalCountDetail: fetchedData.tableReport.vendorOrClientOrBULevelTableReport.totalCountDetailIncludingCorporateSharedRequisitionReport
            };
            this._setWorkflowStepsTableData(fetchedTableDataWithoutTotalAndWithCorporateCandidates);
            this._setTechAssessmentTableData(fetchedTableDataWithoutTotalAndWithCorporateCandidates);
            this._setReasonsTableData(fetchedTableDataWithoutTotalAndWithCorporateCandidates, fetchedData.topTenReleasedReasons, fetchedData.topTenNotInterestedReasons);
            this._setCandidatesTotalCount(fetchedTableDataWithoutTotalAndWithCorporateCandidates);
        }
        return [fetchedTableData, fetchedTableDataWithoutTotal, fetchedTableWithCorporateCandidateData, fetchedTableDataWithoutTotalAndWithCorporateCandidates];
    }
    _setWorkflowStepsTableData(fetchedTableData) {
        fetchedTableData.workflowSteps.forEach(step => {
            step.techAssessmentCompleted = step.techAssessmentSubReport.techAssessmentDoneSubReport.completed;
            step.techAssessmentTerminated = step.techAssessmentSubReport.techAssessmentDoneSubReport.terminated;
            step.techAssessmentSuspended = step.techAssessmentSubReport.techAssessmentDoneSubReport.suspended;
            step.techAssessmentTestLeft = step.techAssessmentSubReport.techAssessmentDoneSubReport.testLeft;
            step.techAssessmentExpired = step.techAssessmentSubReport.expired;
            step.techAssessmentNotYetSend = step.techAssessmentSubReport.notYetSend;
            step.techAssessmentSendFailed = step.techAssessmentSubReport.sendFailed;
            step.techAssessmentDone = step.techAssessmentSubReport.techAssessmentDone;
            step.techAssessmentSent = step.techAssessmentSubReport.sent;
            step.techAssessmentCancelled = step.techAssessmentSubReport.cancelled;
        });
        fetchedTableData.totalCountDetail.techAssessmentCompleted = fetchedTableData.totalCountDetail.techAssessmentSubReportTotal.techAssessmentDoneSubReport.completed;
        fetchedTableData.totalCountDetail.techAssessmentTerminated = fetchedTableData.totalCountDetail.techAssessmentSubReportTotal.techAssessmentDoneSubReport.terminated;
        fetchedTableData.totalCountDetail.techAssessmentSuspended = fetchedTableData.totalCountDetail.techAssessmentSubReportTotal.techAssessmentDoneSubReport.suspended;
        fetchedTableData.totalCountDetail.techAssessmentTestLeft = fetchedTableData.totalCountDetail.techAssessmentSubReportTotal.techAssessmentDoneSubReport.testLeft;
        fetchedTableData.totalCountDetail.techAssessmentExpired = fetchedTableData.totalCountDetail.techAssessmentSubReportTotal.expired;
        fetchedTableData.totalCountDetail.techAssessmentNotYetSend = fetchedTableData.totalCountDetail.techAssessmentSubReportTotal.notYetSend;
        fetchedTableData.totalCountDetail.techAssessmentSendFailed = fetchedTableData.totalCountDetail.techAssessmentSubReportTotal.sendFailed;
        fetchedTableData.totalCountDetail.techAssessmentSent = fetchedTableData.totalCountDetail.techAssessmentSubReportTotal.sent;
        fetchedTableData.totalCountDetail.techAssessmentCancelled = fetchedTableData.totalCountDetail.techAssessmentSubReportTotal.cancelled;
    }
    _setTechAssessmentTableData(fetchedTableData) {
        fetchedTableData.techAssessmentScores.forEach(score => {
            score.completed = score.candidatesAttemptedSubReport.completed;
            score.failed = score.candidatesAttemptedSubReport.failed;
            score.passed = score.candidatesAttemptedSubReport.passed;
            score.terminated = score.candidatesAttemptedSubReport.terminated;
            score.suspended = score.candidatesAttemptedSubReport.suspended;
            score.testLeft = score.candidatesAttemptedSubReport.testLeft;
        });
        fetchedTableData.totalCountDetail.completed = fetchedTableData.totalCountDetail.candidatesAttemptedSubReportTotal.completed;
        fetchedTableData.totalCountDetail.failed = fetchedTableData.totalCountDetail.candidatesAttemptedSubReportTotal.failed;
        fetchedTableData.totalCountDetail.passed = fetchedTableData.totalCountDetail.candidatesAttemptedSubReportTotal.passed;
        fetchedTableData.totalCountDetail.terminated = fetchedTableData.totalCountDetail.candidatesAttemptedSubReportTotal.terminated;
        fetchedTableData.totalCountDetail.suspended = fetchedTableData.totalCountDetail.candidatesAttemptedSubReportTotal.suspended;
        fetchedTableData.totalCountDetail.testLeft = fetchedTableData.totalCountDetail.candidatesAttemptedSubReportTotal.testLeft;
    }
    _setReasonsTableData(fetchedTableData, topTenReleasedReasons, topTenNotInterestedReasons) {
        this._sortReasonsTableData(fetchedTableData, topTenReleasedReasons, topTenNotInterestedReasons);
        for (let releaseReason of fetchedTableData.releaseReasons) {
            let index = 0;
            for (let reasonName in releaseReason.releaseReasons) {
                let field = 'reason' + index;
                let countField = 'reason' + index + 'count';
                releaseReason[field] = reasonName;
                releaseReason[countField] = releaseReason.releaseReasons[reasonName];
                index++;
            }
        }
        for (let reason of fetchedTableData.notInterestedReasons) {
            let index = 0;
            for (let reasonName in reason.notInterestedReasons) {
                let field = 'reason' + index;
                let countField = 'reason' + index + 'count';
                reason[field] = reasonName;
                reason[countField] = reason.notInterestedReasons[reasonName];
                index++;
            }
        }
    }
    _sortReasonsTableData(fetchedTableData, topTenReleasedReasons, topTenNotInterestedReasons) {
        for (let releaseReason of fetchedTableData.releaseReasons) {
            let allReleaseReasons = angular.copy(releaseReason.releaseReasons);
            releaseReason.releaseReasons = {};
            for (let topReason of topTenReleasedReasons) {
                for (let reason in allReleaseReasons) {
                    if (reason === topReason) {
                        releaseReason.releaseReasons[reason] = allReleaseReasons[reason];
                    }
                }
            }
            for (let reason in allReleaseReasons) {
                if (releaseReason.releaseReasons[reason] == undefined) {
                    releaseReason.releaseReasons[reason] = allReleaseReasons[reason];
                }
            }
        }
        for (let notInterestedReason of fetchedTableData.notInterestedReasons) {
            let allNotInterestedReasons = angular.copy(notInterestedReason.notInterestedReasons);
            notInterestedReason.notInterestedReasons = {};
            for (let topReason of topTenNotInterestedReasons) {
                for (let reason in allNotInterestedReasons) {
                    if (reason === topReason) {
                        notInterestedReason.notInterestedReasons[reason] = allNotInterestedReasons[reason];
                    }
                }
            }
            for (let reason in allNotInterestedReasons) {
                if (notInterestedReason.notInterestedReasons[reason] == undefined) {
                    notInterestedReason.notInterestedReasons[reason] = allNotInterestedReasons[reason];
                }
            }
        }
    }
    _setCandidatesTotalCount(fetchedTableData) {
        for (let stepSection in fetchedTableData) {
            if (stepSection !== 'totalCandidatesCount' && stepSection !== 'filteredCandidateCount' && stepSection !== 'yieldRatio' && stepSection !== 'conversionRate' && stepSection !== 'totalCountDetail') {
                for (let step of fetchedTableData[stepSection]) {
                    step.candidatesCountDisplay = step.candidatesCount + '/' + step.totalCandidatesCount;
                }
            }
        }
    }
    _getMassagedGraphData(fetchedData, companyName, viewReportBy) {
        let sortedClients = fetchedData.graphReport['vendorOrClientOrBUNames'].sort();
        delete fetchedData.graphReport.vendorOrClientOrBUNames;
        let clients = [];
        if (viewReportBy == 'vendor') {
            clients = sortedClients.filter(client => client !== companyName);
        }
        else {
            clients = [...sortedClients];
        }
        let clientsWithCorporate = [...sortedClients];
        let fetchedGraphData = {
            clients: clients,
            workflowSteps: fetchedData.graphReport['workflowStepsGraphReport'],
            jobMatchesScores: fetchedData.graphReport['jobMatchesScoresGraphReport'],
            techAssessmentScores: fetchedData.graphReport['techAssessmentScoreGraphReportDTO'],
            releaseReasons: fetchedData.graphReport['releaseReasons'],
            notInterestedReasons: fetchedData.graphReport['notInterestedReasons']
        };
        let graph = this._getMassagedReasonsGraphData(fetchedGraphData, fetchedData.topTenReleasedReasons, fetchedData.topTenNotInterestedReasons);
        fetchedGraphData.clients = [...clientsWithCorporate];
        let graphWithCorporate = this._getMassagedReasonsGraphData(fetchedGraphData, fetchedData.topTenReleasedReasons, fetchedData.topTenNotInterestedReasons);
        return [graph, graphWithCorporate];
    }
    _getMassagedReasonsGraphData(fetchedGraphData, topTenReleasedReasons, topTenNotInterestedReasons) {
        let graph = this._initGraph();
        for (let vendor of fetchedGraphData.clients) {
            graph.clients.push(vendor);
            for (let section in fetchedGraphData) {
                if (section !== 'clients' && section !== 'releaseReasons' && section !== 'notInterestedReasons') {
                    for (let step in fetchedGraphData[section]) {
                        graph[section][step].push(fetchedGraphData[section][step][vendor]);
                    }
                }
            }
        }
        for (let section in fetchedGraphData) {
            if (section == 'releaseReasons' || section == 'notInterestedReasons') {
                for (let step in fetchedGraphData[section]) {
                    let countsWithUnSortedVendorName = fetchedGraphData[section][step]['counts'];
                    let countsWithSortedVendorName = Object.keys(countsWithUnSortedVendorName).sort().reduce((obj, key) => {
                        obj[key] = countsWithUnSortedVendorName[key];
                        return obj;
                    }, {});
                    let counts = [];
                    for (let count in countsWithSortedVendorName) {
                        counts.push(countsWithSortedVendorName[count]);
                    }
                    graph[section].push({
                        reason: fetchedGraphData[section][step]['reason'],
                        counts: counts
                    });
                }
            }
        }
        this._setGraphOtherReleaseAndNotInterestedReasons(graph, topTenReleasedReasons, topTenNotInterestedReasons);
        return graph;
    }
    _setGraphOtherReleaseAndNotInterestedReasons(graph, topTenReleasedReasons, topTenNotInterestedReasons) {
        let allReleaseReasons = graph.releaseReasons;
        let allNotInterestedReasons = graph.notInterestedReasons;
        graph.releaseReasons = [];
        graph.notInterestedReasons = [];
        for (let topReason of topTenReleasedReasons) {
            let filteredReasons = allReleaseReasons.filter(reason => reason.reason === topReason);
            if (filteredReasons.length > 0) {
                graph.releaseReasons.push(filteredReasons[0]);
            }
        }
        for (let topReason of topTenNotInterestedReasons) {
            let filteredReasons = allNotInterestedReasons.filter(reason => reason.reason === topReason);
            if (filteredReasons.length > 0) {
                graph.notInterestedReasons.push(filteredReasons[0]);
            }
        }
        graph.otherReleaseReasons = allReleaseReasons.filter(reason => !graph.releaseReasons.includes(reason));
        graph.otherNotInterestedReasons = allNotInterestedReasons.filter(reason => !graph.notInterestedReasons.includes(reason));
    }
    _initGraph() {
        return {
            clients: [],
            workflowSteps: {
                candidates: [],
                recruiterScreeningSkipped: [],
                recruiterScreeningDone: [],
                recruiterScreeningPassed: [],
                recruiterScreeningFailed: [],
                candidatesViaTechAssessment: [],
                candidateAttemptedCountInfo: [],
                techAssessmentAttemptCountInfo: [],
                techAssessmentSkipped: [],
                techAssessmentDone: [],
                passedAssessmentAttemptCountInfo: [],
                techAssessmentPassed: [],
                techAssessmentFailed: [],
                techAssessmentSent: [],
                valueAssessmentSkipped: [],
                valueAssessmentDone: [],
                valueAssessmentPassed: [],
                valueAssessmentFailed: [],
                valueAssessmentSent: [],
                phoneScreenSkipped: [],
                phoneScreenScheduled: [],
                phoneScreenDone: [],
                phoneScreenPassed: [],
                phoneScreenFailed: [],
                interviewScheduled: [],
                interviewDone: [],
                interviewPassed: [],
                interviewFailed: [],
                hired: [],
                filled: [],
                released: [],
                notInterested: []
            },
            jobMatchesScores: {
                notApplicable: [],
                veryPoor: [],
                poor: [],
                fair: [],
                good: [],
                veryGood: [],
                excellent: [],
                exceptional: [],
                hired: []
            },
            techAssessmentScores: {
                skipped: [],
                beginner: [],
                intermediate: [],
                experienced: [],
                inTechAssessmentInfo: [],
                sentTechAssessmentInfo: [],
                techAssessmentDoneInfo: [],
                candidatesViaTechAssessment: [],
                techAssessmentAttemptCountInfo: [],
                candidateAttemptedCountInfo: [],
                passedAssessmentAttemptCountInfo: [],
                proficient: []
            },
            releaseReasons: [],
            otherReleaseReasons: [],
            notInterestedReasons: [],
            otherNotInterestedReasons: []
        };
    }
    getGridOptions(sectionNumber, vendorsOrClientsOrBusLabel, reportData, isAllData, clientOrBuList) {
        let colDefs = this.getColumnDefs(sectionNumber, vendorsOrClientsOrBusLabel, reportData, isAllData);
        let rowData = this.getRowData(sectionNumber, reportData);
        let gridOptions = {
            columnDefs: colDefs,
            rowData: rowData,
            rowClassRules: {
                'opacity-half': (params) => {
                    if (params.data.buNameForVendorReport !== null) {
                        return clientOrBuList.filter(clientOrBu => clientOrBu.unFormattedName == params.data.buNameForVendorReport && !clientOrBu.inCurrentScope).length > 0;
                    }
                    else {
                        return clientOrBuList.filter(clientOrBu => clientOrBu.unFormattedName == params.data.vendorOrClientOrBUName && !clientOrBu.inCurrentScope).length > 0;
                    }
                }
            },
            // rowSelection: 'multiple',
            // onModelUpdated: onModelUpdated,
            // suppressRowClickSelection: true,
            defaultColDef: {
                // sortable: true,
                // filter: true,
                // resizable: true,
                width: 140,
                sortable: true,
                resizable: true,
            },
            pinnedBottomRowData: this.getFooterRowData(sectionNumber, reportData, isAllData),
            components: {
                customPinnedRowRenderer: CustomPinnedRowRenderer,
            }
            // suppressHorizontalScroll: true,
            // onFirstDataRendered: onFirstDataRendered,
            // alignedGrids: []
            // angularCompileRows: true
        };
        if (rowData.length < 10) {
            gridOptions.domLayout = 'autoHeight';
        }
        return { gridOptions: gridOptions, gridOptionsFooter: {} };
    }
    getColumnDefs(sectionNumber, vendorsOrClientsOrBusLabel, reportData, isAllData) {
        let columnDefs = [];
        let clientOrBuLabel = vendorsOrClientsOrBusLabel;
        let fixedCols = [
            {
                headerName: vendorsOrClientsOrBusLabel,
                headerTooltip: vendorsOrClientsOrBusLabel,
                field: "vendorOrClientOrBUName",
                sort: 'asc',
                // width: 150, 
                pinned: true,
                pinnedRowCellRenderer: 'customPinnedRowRenderer',
                pinnedRowCellRendererParams: {
                    style: { 'font-weight': 600 },
                }
            }
        ];
        if (vendorsOrClientsOrBusLabel == 'Vendor' && isAllData) {
            clientOrBuLabel = "BU";
            fixedCols.push({
                headerName: clientOrBuLabel,
                headerTooltip: clientOrBuLabel,
                field: "buNameForVendorReport",
                // width: 150, 
                pinned: true,
                pinnedRowCellRenderer: 'customPinnedRowRenderer',
                pinnedRowCellRendererParams: {
                    style: { 'font-weight': 600 },
                }
            });
        }
        let reqCols = [
            {
                headerName: "Req #",
                headerTooltip: "Req #",
                field: "requisitionNumber",
                // width: 100,
                pinned: true,
                pinnedRowCellRenderer: 'customPinnedRowRenderer',
                pinnedRowCellRendererParams: {
                    style: { 'font-weight': 600 }
                }
            },
            {
                headerName: "Role Name",
                headerTooltip: "Role Name",
                field: "roleName",
                // width: 125,
                pinned: true, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                pinnedRowCellRendererParams: {
                    style: { 'font-weight': 600 },
                }
            }
        ];
        let candidatesCol = {
            headerName: "Candidates",
            headerTooltip: "# of candidates in Req/# of candidates in " + clientOrBuLabel,
            field: "candidatesCountDisplay",
            pinned: true,
            sortable: false,
            // width: 125, 
            pinnedRowCellRenderer: 'customPinnedRowRenderer',
            pinnedRowCellRendererParams: {
                style: { 'font-weight': 600 },
            }
        };
        if (isAllData) {
            fixedCols = fixedCols.concat(reqCols);
        }
        fixedCols.push(candidatesCol);
        // if(this.selectedClientOrBuList.length == 1) {
        //     fixedColDef = {
        //         headerName: this.selectedClientOrBuList[0].name,
        //         children: [
        //             {
        //                 headerName: "Req #", field: "requisitionNumber", width: 100,
        //                 pinned: true
        //             },
        //             {
        //                 headerName: "Role Name", field: "roleName", width: 125,
        //                 pinned: true
        //             },
        //             { headerName: "Candidates", field: "candidatesCount", pinned: true, width: 125 }
        //         ]
        //     }
        // }
        switch (sectionNumber) {
            case 0:
                columnDefs = [
                    {
                        headerName: "Recruiter Screening",
                        headerTooltip: "Recruiter Screening",
                        children: [
                            {
                                headerName: "In Recruiter Screening", headerTooltip: "In Recruiter Screening", field: "inRecruiterScreening", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Skipped", headerTooltip: "Skipped", field: "recruiterScreeningSkipped", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Done", headerTooltip: "Done", field: "recruiterScreeningDone", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Passed", headerTooltip: "Passed", field: "recruiterScreeningPassed", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Failed", headerTooltip: "Failed", field: "recruiterScreeningFailed", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            }
                        ]
                    },
                    {
                        headerName: 'Tech Assessment',
                        headerTooltip: "Tech Assessment",
                        children: [
                            {
                                headerName: "In Tech Assessment", headerTooltip: "In Tech Assessment", field: "inTechAssessment", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Not Yet Sent", headerTooltip: "Not Yet Sent", field: "techAssessmentNotYetSend", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Canceled", headerTooltip: "Canceled", field: "techAssessmentCancelled", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Expired", headerTooltip: "Expired", field: "techAssessmentExpired", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Send Failed", headerTooltip: "Send Failed", field: "techAssessmentSendFailed", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Sent", headerTooltip: "Sent", field: "techAssessmentSent", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Completed", headerTooltip: "Completed", field: "techAssessmentCompleted", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Test Left", headerTooltip: "Test Left", field: "techAssessmentTestLeft", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Suspended", headerTooltip: "Suspended", field: "techAssessmentSuspended", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Terminated", headerTooltip: "Terminated", field: "techAssessmentTerminated", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Skipped", headerTooltip: "Skipped", field: "techAssessmentSkipped", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Candidates Attempted", headerTooltip: "Candidates Attempted", field: "attemptedCandidatesCount", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Assessments Attempted", headerTooltip: "Assessments Attempted", field: "techAssessmentAttemptCount", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Done", headerTooltip: "Done", field: "techAssessmentDone", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Passed", headerTooltip: "Passed", field: "techAssessmentPassed", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Failed", headerTooltip: "Failed", field: "techAssessmentFailed", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            }
                        ]
                    },
                    {
                        headerName: 'Value Assessment',
                        headerTooltip: "Value Assessment",
                        children: [
                            {
                                headerName: "In Value Assessment", headerTooltip: "In Value Assessment", field: "inValueAssessment", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Skipped", headerTooltip: "Skipped", field: "valueAssessmentSkipped", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Sent", headerTooltip: "Sent", field: "sentValueAssessment", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Done", headerTooltip: "Done", field: "valueAssessmentDone", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Passed", headerTooltip: "Passed", field: "valueAssessmentPassed", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Failed", headerTooltip: "Failed", field: "valueAssessmentFailed", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            }
                        ]
                    },
                    {
                        headerName: 'Phone Screen',
                        headerTooltip: "Phone Screen",
                        children: [
                            {
                                headerName: "In Phone Screen", headerTooltip: "In Phone Screen", field: "inPhoneScreen", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Skipped", headerTooltip: "Skipped", field: "phoneScreenSkipped", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Scheduled", headerTooltip: "Scheduled", field: "phoneScreenScheduled", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Done", headerTooltip: "Done", field: "phoneScreenDone", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Passed", headerTooltip: "Passed", field: "phoneScreenPassed", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Failed", headerTooltip: "Failed", field: "phoneScreenFailed", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            }
                        ]
                    },
                    {
                        headerName: 'Interview',
                        headerTooltip: "Interview",
                        children: [
                            {
                                headerName: "In Interview", headerTooltip: "In Interview", field: "inInterview", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Scheduled", headerTooltip: "Scheduled", field: "interviewScheduled", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Done", headerTooltip: "Done", field: "interviewDone", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Passed", headerTooltip: "Passed", field: "interviewPassed", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Failed", headerTooltip: "Failed", field: "interviewFailed", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            }
                        ]
                    },
                    {
                        headerName: 'Filled',
                        headerTooltip: "Filled",
                        width: 90,
                        children: [
                            {
                                headerName: '', field: "filled", width: 90, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            }
                        ]
                    },
                    {
                        headerName: 'Hired', headerTooltip: "Hired", field: "hired", width: 90,
                        children: [
                            {
                                headerName: '', field: "hired", width: 90, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            }
                        ]
                    },
                    {
                        headerName: 'Released', headerTooltip: "Released", field: "released", width: 90,
                        children: [
                            {
                                headerName: '', field: "released", width: 90, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            }
                        ]
                    },
                    {
                        headerName: 'Not Interested', headerTooltip: "Not Interested", width: 90,
                        children: [
                            {
                                headerName: '', field: "notInterested", width: 90, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            }
                        ]
                    },
                    {
                        headerName: 'Yield Ratio %',
                        headerTooltip: "Yield Ratio %",
                        width: 120,
                        children: [
                            {
                                headerName: '', field: "yieldRatio", width: 90, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                headerComponentParams: {
                                    template: this._getHeaderTemplate('yieldRatio')
                                }
                            }
                        ]
                    },
                    {
                        headerName: 'Conversion Rate %',
                        headerTooltip: "Conversion Rate %",
                        width: 120,
                        children: [
                            {
                                headerName: '', field: "conversionRate", width: 90, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                headerComponentParams: {
                                    template: this._getHeaderTemplate('conversionRate')
                                }
                            }
                        ]
                    }
                ];
                let fixedColDef = {
                    headerName: '',
                    children: fixedCols
                };
                columnDefs.unshift(fixedColDef);
                break;
            case 1:
                columnDefs = [
                    {
                        headerName: "Not Applicable", headerTooltip: "Not Applicable", field: "notApplicable", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        },
                    },
                    {
                        headerName: "Very Poor (1-20%)", headerTooltip: "Very Poor (1-20%)", field: "veryPoor", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        },
                    },
                    {
                        headerName: "Poor (21-40%)", headerTooltip: "Poor (21-40%)", field: "poor", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        },
                    },
                    {
                        headerName: "Fair (41-60%)", headerTooltip: "Fair (41-60%)", field: "fair", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        },
                    },
                    {
                        headerName: "Good (61-70%)", headerTooltip: "Good (61-70%)", field: "good", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        },
                    }, {
                        headerName: "Very Good (71-80%)", headerTooltip: "Very Good (71-80%)", field: "veryGood", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        },
                    },
                    {
                        headerName: "Excellent (81-90%)", headerTooltip: "Excellent (81-90%)", field: "excellent", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        },
                    },
                    {
                        headerName: "Exceptional (91-100%)", headerTooltip: "Exceptional (91-100%)", field: "exceptional", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        },
                    },
                    {
                        headerName: "Hired", headerTooltip: "Hired", field: "hired", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        }
                    },
                    {
                        headerName: 'Yield Ratio %', headerTooltip: "Yield Ratio %", field: "yieldRatio", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        },
                        headerComponentParams: {
                            template: this._getHeaderTemplate('yieldRatio')
                        }
                    },
                    {
                        headerName: 'Conversion Rate %', headerTooltip: "Conversion Rate %", field: "conversionRate", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        },
                        headerComponentParams: {
                            template: this._getHeaderTemplate('conversionRate')
                        }
                    }
                ];
                columnDefs = fixedCols.concat(columnDefs);
                break;
            case 2:
                columnDefs = [
                    {
                        headerName: "Statistics",
                        headerTooltip: "Statistics",
                        children: [
                            {
                                headerName: "Candidates Attempted", headerTooltip: "Candidates Attempted", field: "attemptedCandidatesCount", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Assessments Attempted", headerTooltip: "Assessments Attempted", field: "techAssessmentAttemptCount", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            }
                        ]
                    },
                    {
                        headerName: "Status",
                        headerTooltip: "Status",
                        children: [
                            {
                                headerName: "Completed", headerTooltip: "Completed", field: "completed", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Test Left", headerTooltip: "Test Left", field: "testLeft", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Suspended", headerTooltip: "Suspended", field: "suspended", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Terminated", headerTooltip: "Terminated", field: "terminated", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                        ]
                    },
                    {
                        headerName: "Success",
                        headerTooltip: "Success",
                        children: [
                            {
                                headerName: "Passed", headerTooltip: "Passed", field: "passed", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            },
                            {
                                headerName: "Failed", headerTooltip: "Failed", field: "failed", width: 110, sortable: false, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                },
                                columnGroupShow: 'open'
                            }
                        ]
                    },
                    {
                        headerName: "Categorization",
                        headerTooltip: "Categorization",
                        children: [
                            {
                                headerName: "Beginner (0-25%)", headerTooltip: "Beginner (0-25%)", field: "beginner", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Intermediate (26-50%)", headerTooltip: "Intermediate (26-50%)", field: "intermediate", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Experienced (51-75%)", headerTooltip: "Experienced (51-75%)", field: "experienced", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                            {
                                headerName: "Proficient (76-100%)", headerTooltip: "Proficient (76-100%)", field: "proficient", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                                pinnedRowCellRendererParams: {
                                    style: { 'font-weight': 600 },
                                }
                            },
                        ]
                    },
                    {
                        headerName: 'Yield Ratio %', headerTooltip: "Yield Ratio %", field: "yieldRatio", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        },
                        headerComponentParams: {
                            template: this._getHeaderTemplate('yieldRatio')
                        }
                    },
                    {
                        headerName: 'Conversion Rate %', headerTooltip: "Conversion Rate %", field: "conversionRate", width: 150, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        },
                        headerComponentParams: {
                            template: this._getHeaderTemplate('conversionRate')
                        }
                    }
                ];
                columnDefs = fixedCols.concat(columnDefs);
                break;
            case 3:
                columnDefs = [];
                let releaseReason = reportData.table.releaseReasons[0];
                let index = 0;
                let releaseReasonsColumnDef = {
                    headerName: "Top 10 Reasons",
                    headerTooltip: "Top 10 Reasons",
                    children: []
                };
                let otherReasonsColumnDef = {
                    headerName: "Other Reasons",
                    headerTooltip: "Other Reasons",
                    children: []
                };
                for (let reasonName in releaseReason.releaseReasons) {
                    let field = 'reason' + index;
                    let countField = 'reason' + index + 'count';
                    let headerName = reasonName;
                    releaseReason[field] = reasonName;
                    releaseReason[countField] = releaseReason.releaseReasons[reasonName];
                    let reasonColumnDef = {
                        headerName: headerName, headerTooltip: headerName, field: countField, width: 120, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        }
                    };
                    if (index < 10) {
                        releaseReasonsColumnDef.children.push(reasonColumnDef);
                    }
                    else {
                        if (index > 12) {
                            reasonColumnDef.columnGroupShow = 'open';
                        }
                        otherReasonsColumnDef.children.push(reasonColumnDef);
                    }
                    index++;
                }
                columnDefs.push(releaseReasonsColumnDef);
                columnDefs.push(otherReasonsColumnDef);
                let releasedCandidatesDef = {
                    headerName: "Released Candidates",
                    headerTooltip: "Released Candidates",
                    field: "releasedCandidates",
                    pinned: true,
                    // width: 125, 
                    pinnedRowCellRenderer: 'customPinnedRowRenderer',
                    pinnedRowCellRendererParams: {
                        style: { 'font-weight': 600 },
                    }
                };
                fixedCols.push(releasedCandidatesDef);
                columnDefs = fixedCols.concat(columnDefs);
                break;
            case 4:
                columnDefs = [];
                let notInterestedReason = reportData.table.notInterestedReasons[0];
                let notInterestedReasonIndex = 0;
                let notInterestedReasonsColumnDef = {
                    headerName: "Top 10 Reasons",
                    headerTooltip: "Top 10 Reasons",
                    children: []
                };
                let otherNotInterestedReasonsColumnDef = {
                    headerName: "Other Reasons",
                    headerTooltip: "Other Reasons",
                    children: []
                };
                for (let reasonName in notInterestedReason.notInterestedReasons) {
                    let field = 'reason' + notInterestedReasonIndex;
                    let countField = 'reason' + notInterestedReasonIndex + 'count';
                    let headerName = reasonName;
                    notInterestedReason[field] = reasonName;
                    notInterestedReason[countField] = notInterestedReason.notInterestedReasons[reasonName];
                    let reasonColumnDef = {
                        headerName: headerName, headerTooltip: headerName, field: countField, width: 120, pinnedRowCellRenderer: 'customPinnedRowRenderer',
                        pinnedRowCellRendererParams: {
                            style: { 'font-weight': 600 },
                        }
                    };
                    if (notInterestedReasonIndex < 10) {
                        notInterestedReasonsColumnDef.children.push(reasonColumnDef);
                    }
                    else {
                        if (notInterestedReasonIndex > 12) {
                            reasonColumnDef.columnGroupShow = 'open';
                        }
                        otherNotInterestedReasonsColumnDef.children.push(reasonColumnDef);
                    }
                    notInterestedReasonIndex++;
                }
                columnDefs.push(notInterestedReasonsColumnDef);
                columnDefs.push(otherNotInterestedReasonsColumnDef);
                let notInterestedCandidatesDef = {
                    headerName: "Not Interested Candidates",
                    headerTooltip: "Not Interested Candidates",
                    field: "notInterestedCandidates",
                    pinned: true,
                    // width: 125, 
                    pinnedRowCellRenderer: 'customPinnedRowRenderer',
                    pinnedRowCellRendererParams: {
                        style: { 'font-weight': 600 },
                    }
                };
                fixedCols.push(notInterestedCandidatesDef);
                columnDefs = fixedCols.concat(columnDefs);
                break;
            default:
            //do nothing
        }
        return columnDefs;
    }
    _getHeaderTemplate(columnName) {
        let tooltipContent = '';
        if (columnName == 'conversionRate') {
            tooltipContent = "# Hired/# Candidates";
        }
        else if (columnName == 'yieldRatio') {
            tooltipContent = "# Interviewed/# Candidates";
        }
        return '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '     <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '    <span class="fas fa-info-circle text-primary pl-5" data-toggle="popover" title="' + tooltipContent + '" data-content="Some content inside the popover"></span>' +
            '  </div>' +
            '</div>';
    }
    getRowData(sectionNumber, reportData) {
        switch (sectionNumber) {
            case 0:
                return reportData.table.workflowSteps;
                break;
            case 1:
                return reportData.table.jobMatchesScores;
                break;
            case 2:
                return reportData.table.techAssessmentScores;
                break;
            case 3:
                return reportData.table.releaseReasons;
                break;
            case 4:
                return reportData.table.notInterestedReasons;
                break;
            default:
            //do nothing
        }
    }
    getFooterRowData(sectionNumber, reportData, isAllData) {
        let fieldWithoutCounts = ["vendorOrClientOrBUName", "buNameForVendorReport", "requisitionNumber", "roleName", "candidatesCountDisplay"];
        let totalCountDetail = reportData.table.totalCountDetail;
        switch (sectionNumber) {
            case 0:
                let totalOfWorkflowStep = {
                    vendorOrClientOrBUName: "Total",
                    buNameForVendorReport: "-",
                    requisitionNumber: "-",
                    roleName: "-",
                    candidatesCount: 0,
                    totalCandidatesCount: 0,
                    filteredCandidateCount: 0,
                    candidatesCountDisplay: 0,
                    inRecruiterScreening: 0,
                    recruiterScreeningSkipped: 0,
                    recruiterScreeningDone: 0,
                    recruiterScreeningPassed: 0,
                    recruiterScreeningFailed: 0,
                    inTechAssessment: 0,
                    techAssessmentSkipped: 0,
                    viaTechAssessment: 0,
                    techAssessmentAttemptCount: 0,
                    attemptedCandidatesCount: 0,
                    techAssessmentDone: 0,
                    techAssessmentPassed: 0,
                    techAssessmentFailed: 0,
                    techAssessmentCompleted: 0,
                    techAssessmentTerminated: 0,
                    techAssessmentSuspended: 0,
                    techAssessmentTestLeft: 0,
                    techAssessmentExpired: 0,
                    techAssessmentNotYetSend: 0,
                    techAssessmentSendFailed: 0,
                    techAssessmentSent: 0,
                    techAssessmentCancelled: 0,
                    inValueAssessment: 0,
                    valueAssessmentSkipped: 0,
                    valueAssessmentDone: 0,
                    valueAssessmentPassed: 0,
                    valueAssessmentFailed: 0,
                    sentValueAssessment: 0,
                    inPhoneScreen: 0,
                    phoneScreenSkipped: 0,
                    phoneScreenScheduled: 0,
                    phoneScreenDone: 0,
                    phoneScreenPassed: 0,
                    phoneScreenFailed: 0,
                    inInterview: 0,
                    interviewScheduled: 0,
                    interviewDone: 0,
                    interviewPassed: 0,
                    interviewFailed: 0,
                    filled: 0,
                    hired: 0,
                    released: 0,
                    notInterested: 0,
                    conversionRate: 0,
                    yieldRatio: 0
                    // ,
                    // sourceQuality: 0
                };
                for (let field in totalOfWorkflowStep) {
                    if (!fieldWithoutCounts.includes(field)) {
                        totalOfWorkflowStep[field] = totalCountDetail[field];
                    }
                    else if (field === "candidatesCountDisplay") {
                        totalOfWorkflowStep.candidatesCountDisplay = totalCountDetail.filteredCandidateCount + '/' + totalCountDetail.totalCandidatesCount;
                    }
                }
                return [totalOfWorkflowStep];
                break;
            case 1:
                let totalJobMatchScore = {
                    vendorOrClientOrBUName: "Total",
                    buNameForVendorReport: "-",
                    requisitionNumber: "-",
                    roleName: "-",
                    candidatesCount: 0,
                    totalCandidatesCount: 0,
                    filteredCandidateCount: 0,
                    candidatesCountDisplay: 0,
                    veryGood: 0,
                    notApplicable: 0,
                    veryPoor: 0,
                    poor: 0,
                    fair: 0,
                    good: 0,
                    excellent: 0,
                    exceptional: 0,
                    hired: 0,
                    conversionRate: 0,
                    yieldRatio: 0
                };
                for (let field in totalJobMatchScore) {
                    if (!fieldWithoutCounts.includes(field)) {
                        totalJobMatchScore[field] = totalCountDetail[field];
                    }
                    else if (field === "candidatesCountDisplay") {
                        totalJobMatchScore.candidatesCountDisplay = totalCountDetail.filteredCandidateCount + '/' + totalCountDetail.totalCandidatesCount;
                    }
                }
                return [totalJobMatchScore];
                break;
            case 2:
                let totalTechAssessmentScore = {
                    vendorOrClientOrBUName: "Total",
                    buNameForVendorReport: "-",
                    requisitionNumber: "-",
                    roleName: "-",
                    candidatesCount: 0,
                    totalCandidatesCount: 0,
                    filteredCandidateCount: 0,
                    candidatesCountDisplay: 0,
                    skipped: 0,
                    sent: 0,
                    cancelled: 0,
                    inTechAssessment: 0,
                    viaTechAssessment: 0,
                    techAssessmentAttemptCount: 0,
                    attemptedCandidatesCount: 0,
                    beginner: 0,
                    intermediate: 0,
                    experienced: 0,
                    proficient: 0,
                    conversionRate: 0,
                    yieldRatio: 0,
                    completed: 0,
                    failed: 0,
                    passed: 0,
                    terminated: 0,
                    suspended: 0,
                    testLeft: 0,
                    passed: 0,
                    failed: 0,
                    expired: 0,
                    notYetSend: 0,
                    sendFailed: 0,
                    techAssessmentDone: 0
                };
                for (let field in totalTechAssessmentScore) {
                    if (!fieldWithoutCounts.includes(field)) {
                        totalTechAssessmentScore[field] = totalCountDetail[field];
                    }
                    else if (field === "candidatesCountDisplay") {
                        totalTechAssessmentScore.candidatesCountDisplay = totalCountDetail.filteredCandidateCount + '/' + totalCountDetail.totalCandidatesCount;
                    }
                }
                return [totalTechAssessmentScore];
                break;
            case 3:
                let totalReleaseReason = {
                    vendorOrClientOrBUName: "Total",
                    totalCandidatesCount: 0,
                    candidatesCountDisplay: 0,
                    filteredCandidateCount: 0,
                    buNameForVendorReport: "-",
                    requisitionNumber: "-",
                    roleName: "-",
                    releasedCandidates: 0
                };
                let releaseReasons = reportData.table.releaseReasons[0].releaseReasons;
                let index = 0;
                // set reason names and counts fields
                for (let reasonName in releaseReasons) {
                    let field = 'reason' + index;
                    let countField = 'reason' + index + 'count';
                    totalReleaseReason[field] = reasonName;
                    totalReleaseReason[countField] = totalCountDetail.releasedCandidatesByReason[reasonName];
                    index++;
                }
                totalReleaseReason.candidatesCountDisplay = totalCountDetail.filteredCandidateCount + '/' + totalCountDetail.totalCandidatesCount;
                totalReleaseReason.releasedCandidates = totalCountDetail.released;
                totalReleaseReason.totalCandidatesCount = totalCountDetail.totalCandidatesCount;
                return [totalReleaseReason];
                break;
            case 4:
                let totalNotInterestedReason = {
                    vendorOrClientOrBUName: "Total",
                    totalCandidatesCount: 0,
                    candidatesCountDisplay: 0,
                    filteredCandidateCount: 0,
                    buNameForVendorReport: "-",
                    requisitionNumber: "-",
                    roleName: "-",
                    notInterestedCandidates: 0
                };
                let notInterestedReasons = reportData.table.notInterestedReasons[0].notInterestedReasons;
                let reasonIndex = 0;
                // set reason names and counts fields
                for (let reasonName in notInterestedReasons) {
                    let field = 'reason' + reasonIndex;
                    let countField = 'reason' + reasonIndex + 'count';
                    totalNotInterestedReason[field] = reasonName;
                    totalNotInterestedReason[countField] = totalCountDetail.notInterestedCandidatesByReason[reasonName];
                    reasonIndex++;
                }
                totalNotInterestedReason.candidatesCountDisplay = totalCountDetail.filteredCandidateCount + '/' + totalCountDetail.totalCandidatesCount;
                totalNotInterestedReason.notInterestedCandidates = totalCountDetail.notInterested;
                totalNotInterestedReason.totalCandidatesCount = totalCountDetail.totalCandidatesCount;
                return [totalNotInterestedReason];
                break;
            default:
            //do nothing
        }
    }
    getGraphSettings(sectionNumber, graph) {
        return {
            series: this.getGraphSeries(sectionNumber, graph),
            labels: graph.clients,
            colors: this.getGraphColors(sectionNumber),
            data: this.getGraphDataSet(sectionNumber, graph),
            options: this.getGraphOptions(sectionNumber, graph)
        };
    }
    getGraphSeries(sectionNumber, graph) {
        switch (sectionNumber) {
            case 0:
                return [
                    "Candidates",
                    "Recruiter Screening Done",
                    "Recruiter Screening Passed",
                    "Candidates Attempted",
                    "Tech Assessment Passed",
                    "Tech Assessment Failed",
                    "Value Assessment Done",
                    "Value Assessment Passed",
                    "Phone Screen Done",
                    "Phone Screen Passed",
                    "Interview Done",
                    "Interview Passed",
                    "Filled",
                    "Hired"
                ];
                break;
            case 1:
                return [
                    "Candidates",
                    'Not Applicable',
                    'Very Poor (1-20%)',
                    'Poor (21-40%)',
                    'Fair (41-60%)',
                    'Good (61-70%)',
                    'Very Good (71-80%)',
                    'Excellent (81-90%)',
                    'Exceptional (91-100%)'
                ];
                break;
            case 2:
                return [
                    'Candidates',
                    'Candidates Attempted',
                    'Assessments Attempted',
                    'Beginner (0-25%)',
                    'Intermediate (26-50%)',
                    'Experienced (51-75%)',
                    'Proficient (76-100%)',
                ];
                break;
            case 3:
                let releaseReasons = graph.releaseReasons.map(reason => {
                    return reason.reason;
                });
                releaseReasons.unshift("Candidates");
                return releaseReasons;
                break;
            case 4:
                let notInterestedReasons = graph.notInterestedReasons.map(reason => {
                    return reason.reason;
                });
                notInterestedReasons.unshift("Candidates");
                return notInterestedReasons;
                break;
            case 5:
                let otherReleaseReasons = graph.otherReleaseReasons.map(reason => {
                    return reason.reason;
                });
                otherReleaseReasons.unshift("Candidates");
                return otherReleaseReasons;
                break;
            case 6:
                let otherNotInterestedReasons = graph.otherNotInterestedReasons.map(reason => {
                    return reason.reason;
                });
                otherNotInterestedReasons.unshift("Candidates");
                return otherNotInterestedReasons;
                break;
            default:
            //do nothing
        }
    }
    getGraphColors(sectionNumber) {
        switch (sectionNumber) {
            case 0:
                return [
                    {
                        backgroundColor: 'rgba(148,191,189,1)',
                    },
                    {
                        backgroundColor: 'rgba(205,127,50,1)',
                    },
                    {
                        backgroundColor: 'rgba(160,82,45,1)',
                    },
                    {
                        backgroundColor: 'rgba(7,169,160,1)',
                    },
                    {
                        backgroundColor: 'rgba(3,169,244,1)',
                    },
                    {
                        backgroundColor: 'rgba(280, 190, 71,1)',
                    },
                    {
                        backgroundColor: 'rgba(197, 162, 71,1)',
                    },
                    {
                        backgroundColor: 'rgba(255, 99, 71,1)',
                    },
                    {
                        backgroundColor: 'rgba(253,183,104,1)',
                    },
                    {
                        backgroundColor: 'rgba(251,134,4,1)',
                    },
                    {
                        backgroundColor: 'rgba(254,245,144,1)',
                    },
                    {
                        backgroundColor: 'rgba(253,237,42,1)',
                    },
                    {
                        backgroundColor: 'rgba(41, 241, 195, 1)',
                    },
                    {
                        backgroundColor: 'rgba(127,189,50,1)',
                    }
                ];
                break;
            case 1:
                return [
                    {
                        backgroundColor: 'rgba(148,191,189,1)',
                    },
                    {
                        backgroundColor: 'rgb(224,224,224,1)',
                    },
                    {
                        backgroundColor: 'rgba(227,38,54,1)',
                    },
                    {
                        backgroundColor: 'rgba(253,183,104,1)',
                    },
                    {
                        backgroundColor: 'rgba(251,134,4,1)',
                    },
                    {
                        backgroundColor: 'rgba(254,245,144,1)',
                    },
                    {
                        backgroundColor: 'rgba(253,237,42,1)',
                    },
                    {
                        backgroundColor: 'rgba(70,191,189,1)',
                    },
                    {
                        backgroundColor: 'rgba(127,189,50,1)',
                    }
                ];
                break;
            case 2:
                return [
                    {
                        backgroundColor: 'rgba(148,191,189,1)',
                    },
                    {
                        backgroundColor: 'rgb(221,282,290,1)',
                    },
                    {
                        backgroundColor: 'rgb(224,224,224,1)',
                    },
                    {
                        backgroundColor: 'rgba(251,134,4,1)',
                    },
                    {
                        backgroundColor: 'rgba(253,237,42,1)',
                    },
                    {
                        backgroundColor: 'rgba(3,169,244,1)',
                    },
                    {
                        backgroundColor: 'rgba(127,189,50,1)',
                    }
                ];
                break;
            case 3:
                return [
                    {
                        backgroundColor: 'rgba(148,191,189,1)',
                    },
                    {
                        backgroundColor: 'rgba(200,203,189,1)',
                    },
                    {
                        backgroundColor: 'rgba(205,127,50,1)',
                    },
                    {
                        backgroundColor: 'rgba(160,82,45,1)',
                    },
                    {
                        backgroundColor: 'rgba(70,191,189,1)',
                    },
                    {
                        backgroundColor: 'rgba(3,169,244,1)',
                    },
                    {
                        backgroundColor: 'rgba(253,183,104,1)',
                    },
                    {
                        backgroundColor: 'rgba(251,134,4,1)',
                    },
                    {
                        backgroundColor: 'rgba(254,245,144,1)',
                    },
                    {
                        backgroundColor: 'rgba(253,237,42,1)',
                    },
                    {
                        backgroundColor: 'rgba(127,189,50,1)',
                    }
                ];
                break;
            case 4:
                return [
                    {
                        backgroundColor: 'rgba(148,191,189,1)',
                    },
                    {
                        backgroundColor: 'rgba(200,203,189,1)',
                    },
                    {
                        backgroundColor: 'rgba(205,127,50,1)',
                    },
                    {
                        backgroundColor: 'rgba(160,82,45,1)',
                    },
                    {
                        backgroundColor: 'rgba(70,191,189,1)',
                    },
                    {
                        backgroundColor: 'rgba(3,169,244,1)',
                    },
                    {
                        backgroundColor: 'rgba(253,183,104,1)',
                    },
                    {
                        backgroundColor: 'rgba(251,134,4,1)',
                    },
                    {
                        backgroundColor: 'rgba(254,245,144,1)',
                    },
                    {
                        backgroundColor: 'rgba(253,237,42,1)',
                    },
                    {
                        backgroundColor: 'rgba(127,189,50,1)',
                    }
                ];
                break;
            case 5:
                return [
                    {
                        backgroundColor: 'rgba(148,191,189,1)',
                    },
                    {
                        backgroundColor: 'rgba(200,203,189,1)',
                    },
                    {
                        backgroundColor: 'rgba(205,127,50,1)',
                    },
                    {
                        backgroundColor: 'rgba(160,82,45,1)',
                    },
                    {
                        backgroundColor: 'rgba(70,191,189,1)',
                    },
                    {
                        backgroundColor: 'rgba(3,169,244,1)',
                    },
                    {
                        backgroundColor: 'rgba(253,183,104,1)',
                    },
                    {
                        backgroundColor: 'rgba(251,134,4,1)',
                    },
                    {
                        backgroundColor: 'rgba(254,245,144,1)',
                    },
                    {
                        backgroundColor: 'rgba(253,237,42,1)',
                    },
                    {
                        backgroundColor: 'rgba(127,189,50,1)',
                    },
                    {
                        backgroundColor: 'rgba(0,63,92, 1)'
                    },
                    {
                        backgroundColor: 'rgba(47,75,124, 0.8)'
                    },
                    {
                        backgroundColor: 'rgba(102,81,145, 0.8)'
                    },
                    {
                        backgroundColor: 'rgba(160,81,149, 0.8)'
                    },
                    {
                        backgroundColor: 'rgba(212,80,135, 0.8)'
                    },
                ];
            case 6:
                return [
                    {
                        backgroundColor: 'rgba(148,191,189,1)',
                    },
                    {
                        backgroundColor: 'rgba(200,203,189,1)',
                    },
                    {
                        backgroundColor: 'rgba(205,127,50,1)',
                    },
                    {
                        backgroundColor: 'rgba(160,82,45,1)',
                    },
                    {
                        backgroundColor: 'rgba(70,191,189,1)',
                    },
                    {
                        backgroundColor: 'rgba(3,169,244,1)',
                    },
                    {
                        backgroundColor: 'rgba(253,183,104,1)',
                    },
                    {
                        backgroundColor: 'rgba(251,134,4,1)',
                    },
                    {
                        backgroundColor: 'rgba(254,245,144,1)',
                    },
                    {
                        backgroundColor: 'rgba(253,237,42,1)',
                    },
                    {
                        backgroundColor: 'rgba(127,189,50,1)',
                    },
                    {
                        backgroundColor: 'rgba(0,63,92, 1)'
                    },
                    {
                        backgroundColor: 'rgba(47,75,124, 0.8)'
                    },
                    {
                        backgroundColor: 'rgba(102,81,145, 0.8)'
                    },
                    {
                        backgroundColor: 'rgba(160,81,149, 0.8)'
                    },
                    {
                        backgroundColor: 'rgba(212,80,135, 0.8)'
                    },
                ];
                break;
            default:
            //do nothing
        }
    }
    getGraphDataSet(sectionNumber, graph) {
        switch (sectionNumber) {
            case 0:
                return [
                    graph.workflowSteps.candidates,
                    graph.workflowSteps.recruiterScreeningDone,
                    graph.workflowSteps.recruiterScreeningPassed,
                    graph.workflowSteps.candidateAttemptedCountInfo,
                    graph.workflowSteps.techAssessmentPassed,
                    graph.workflowSteps.techAssessmentFailed,
                    graph.workflowSteps.valueAssessmentDone,
                    graph.workflowSteps.valueAssessmentPassed,
                    graph.workflowSteps.phoneScreenDone,
                    graph.workflowSteps.phoneScreenPassed,
                    graph.workflowSteps.interviewDone,
                    graph.workflowSteps.interviewPassed,
                    graph.workflowSteps.filled,
                    graph.workflowSteps.hired
                ];
                break;
            case 1:
                return [
                    graph.workflowSteps.candidates,
                    graph.jobMatchesScores.notApplicable,
                    graph.jobMatchesScores.veryPoor,
                    graph.jobMatchesScores.poor,
                    graph.jobMatchesScores.fair,
                    graph.jobMatchesScores.good,
                    graph.jobMatchesScores.veryGood,
                    graph.jobMatchesScores.excellent,
                    graph.jobMatchesScores.exceptional
                ];
                break;
            case 2:
                return [
                    graph.workflowSteps.candidates,
                    graph.techAssessmentScores.candidateAttemptedCountInfo,
                    graph.techAssessmentScores.techAssessmentAttemptCountInfo,
                    graph.techAssessmentScores.beginner,
                    graph.techAssessmentScores.intermediate,
                    graph.techAssessmentScores.experienced,
                    graph.techAssessmentScores.proficient
                ];
                break;
            case 3:
                let releaseReasons = graph.releaseReasons.map(reason => {
                    return reason.counts;
                });
                releaseReasons.unshift(graph.workflowSteps.candidates);
                return releaseReasons;
                break;
            case 4:
                let notInterestedReasons = graph.notInterestedReasons.map(reason => {
                    return reason.counts;
                });
                notInterestedReasons.unshift(graph.workflowSteps.candidates);
                return notInterestedReasons;
                break;
            case 5:
                let otherReleaseReasons = graph.otherReleaseReasons.map(reason => {
                    return reason.counts;
                });
                otherReleaseReasons.unshift(graph.workflowSteps.candidates);
                return otherReleaseReasons;
                break;
            case 6:
                let otherNotInterestedReasons = graph.otherNotInterestedReasons.map(reason => {
                    return reason.counts;
                });
                otherNotInterestedReasons.unshift(graph.workflowSteps.candidates);
                return otherNotInterestedReasons;
                break;
            default:
            //do nothing
        }
    }
    getGraphOptions(sectionNumber, graph) {
        return {
            // plugins: {
            //     datalabels: {
            //       align: (context) => {
            //           var index = context.dataIndex;
            //         var value = context.dataset.data[index];
            //         var invert = Math.abs(value) <= 1;
            //         return value < 1 ? 'end' : 'start'
            //       },
            //       anchor: 'end',
            //       backgroundColor: null,
            //       borderColor: null,
            //       borderRadius: 4,
            //       borderWidth: 1,
            //       color: '#223388',
            //       font: {
            //         size: 11,
            //         weight: 600
            //       },
            //       offset: 4,
            //       padding: 0,
            //       formatter: (value) => {
            //           return Math.round(value * 10) / 10
            //       }
            //     }
            // },
            // plugins: {
            //     datalabels: {
            //       align: (context) => {
            //           var index = context.dataIndex;
            //         var value = context.dataset.data[index];
            //         var invert = Math.abs(value) <= 1;
            //         return value < 1 ? 'end' : 'start'
            //       },
            //       anchor: 'end',
            //       backgroundColor: null,
            //       borderColor: null,
            //       borderRadius: 4,
            //       borderWidth: 1,
            //       color: '#223388',
            //       font: {
            //         size: 11,
            //         weight: 600
            //       },
            //       offset: 4,
            //       padding: 0,
            //       formatter: (value) => {
            //           return Math.round(value * 10) / 10
            //       }
            //     }
            // },
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 1000
            },
            tooltips: {
                mode: 'label',
                titleFontSize: 14,
                bodyFontSize: 13,
                position: 'nearest',
                callbacks: {
                    label: (tooltipItem, data) => {
                        return data.datasets[tooltipItem.datasetIndex].label + ": " + this._numberWithCommas(tooltipItem.xLabel);
                    }
                }
            },
            scales: {
                yAxes: [{
                        stacked: true,
                        gridLines: { display: false },
                        barThickness: 60,
                        maxBarThickness: 80,
                        ticks: {
                            callback: (value) => {
                                return this._getGraphCustomLabel(value, sectionNumber, graph);
                            }
                        }
                    }],
                xAxes: [{
                        stacked: true,
                        display: 'auto',
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            callback: (value) => { return this._numberWithCommas(value); },
                        },
                    }],
            },
            legend: {
                display: true,
                position: 'right',
                fontSize: 14
            }
        };
    }
    _getGraphCustomLabel(clientName, sectionNumber, graph) {
        let label = clientName;
        let candidatesCountMap = graph.clientNameWithCountsForLabels;
        label = label + ' - ' + candidatesCountMap[clientName];
        return label;
    }
    _numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    getDummyData() {
        return {
            "tableReport": {
                "workflowStepTableReports": [
                    {
                        "vendorOrClientOrBUName": "Test Staffing Company",
                        "requisitionNumber": "REQ-20",
                        "roleName": "Senior Business Analyst",
                        "candidatesCount": 41,
                        "recruiterScreeningSkipped": 3,
                        "recruiterScreeningDone": 0,
                        "recruiterScreeningPassed": 0,
                        "recruiterScreeningFailed": 0,
                        "techAssessmentSkipped": 0,
                        "candidatesViaTechAssessment": 0,
                        "techAssessmentDone": 0,
                        "techAssessmentPassed": 0,
                        "techAssessmentFailed": 0,
                        "phoneScreenSkipped": 1,
                        "phoneScreenScheduled": 0,
                        "phoneScreenDone": 4,
                        "phoneScreenPassed": 0,
                        "phoneScreenFailed": 0,
                        "interviewScheduled": 0,
                        "interviewDone": 0,
                        "interviewPassed": 1,
                        "interviewFailed": 0,
                        "filled": 0,
                        "hired": 0,
                        "released": 2,
                        "notInterested": 5,
                        "conversionRate": 0,
                        "yieldRatio": 0,
                        "sourceQuality": 0,
                        "notInterestedCandidateIds": [
                            "5ee0c12780ee2244851645ad",
                            "5d46d0d480ee22211325df6f",
                            "5d76354780ee22093fc3d518",
                            "5ee22e0680ee2235fc93b95b",
                            "5d7a871380ee225f01269575"
                        ],
                        "releasedCandidateIds": [
                            "5ee79cda80ee222c18370021",
                            "5e4e5a8380ee226d58fd1dbc"
                        ],
                        "hiredCandidateIds": [],
                        "filledCandidateIds": [],
                        "interviewFailedCandidateIds": [],
                        "interviewPassedCandidateIds": [
                            "5d7634fe80ee22093fc3d510"
                        ],
                        "interviewDoneCandidateIds": [],
                        "interviewScheduledCandidateIds": [],
                        "phoneScreenFailedCandidateIds": [],
                        "phoneScreenPassedCandidateIds": [],
                        "phoneScreenDoneCandidateIds": [
                            "5edec5c180ee2261734eb04b",
                            "5d46d0d480ee22211325df6f",
                            "5d7634fe80ee22093fc3d510",
                            "5cf3bf9380ee22651b4e18ed"
                        ],
                        "phoneScreenScheduledCandidateIds": [],
                        "phoneScreenSkippedCandidateIds": [
                            "5d6fb8dc80ee2232e70bb48b"
                        ],
                        "techAssessmentPassedCandidateIds": [],
                        "techAssessmentFailedCandidateIds": [],
                        "techAssessmentSkippedCandidateIds": [],
                        "techAssessmentDoneCandidateIds": [],
                        "recruiterScreeningDoneCandidateIds": [],
                        "recruiterScreeningFailedCandidateIds": [],
                        "recruiterScreeningPassedCandidateIds": [],
                        "recruiterScreeningSkippedCandidateIds": [
                            "5edec5c180ee2261734eb04b",
                            "5e0b195c80ee2239fb213eb1",
                            "5df7758080ee220b1480d065"
                        ]
                    },
                    {
                        "vendorOrClientOrBUName": "Vendor Only Staffing Company",
                        "requisitionNumber": "REQ-20",
                        "roleName": "Senior Business Analyst",
                        "candidatesCount": 7,
                        "recruiterScreeningSkipped": 0,
                        "recruiterScreeningDone": 0,
                        "recruiterScreeningPassed": 0,
                        "recruiterScreeningFailed": 0,
                        "techAssessmentSkipped": 0,
                        "candidatesViaTechAssessment": 0,
                        "techAssessmentDone": 0,
                        "techAssessmentPassed": 0,
                        "techAssessmentFailed": 0,
                        "phoneScreenSkipped": 0,
                        "phoneScreenScheduled": 0,
                        "phoneScreenDone": 0,
                        "phoneScreenPassed": 0,
                        "phoneScreenFailed": 0,
                        "interviewScheduled": 0,
                        "interviewDone": 0,
                        "interviewPassed": 0,
                        "interviewFailed": 0,
                        "filled": 0,
                        "hired": 0,
                        "released": 0,
                        "notInterested": 1,
                        "conversionRate": 0,
                        "yieldRatio": 0,
                        "sourceQuality": 0,
                        "notInterestedCandidateIds": [
                            "5ee2138680ee222a3b65d5ab"
                        ],
                        "releasedCandidateIds": [],
                        "hiredCandidateIds": [],
                        "filledCandidateIds": [],
                        "interviewFailedCandidateIds": [],
                        "interviewPassedCandidateIds": [],
                        "interviewDoneCandidateIds": [],
                        "interviewScheduledCandidateIds": [],
                        "phoneScreenFailedCandidateIds": [],
                        "phoneScreenPassedCandidateIds": [],
                        "phoneScreenDoneCandidateIds": [],
                        "phoneScreenScheduledCandidateIds": [],
                        "phoneScreenSkippedCandidateIds": [],
                        "techAssessmentPassedCandidateIds": [],
                        "techAssessmentFailedCandidateIds": [],
                        "techAssessmentSkippedCandidateIds": [],
                        "techAssessmentDoneCandidateIds": [],
                        "recruiterScreeningDoneCandidateIds": [],
                        "recruiterScreeningFailedCandidateIds": [],
                        "recruiterScreeningPassedCandidateIds": [],
                        "recruiterScreeningSkippedCandidateIds": []
                    }
                ],
                "jobMatchesScoresTableReports": [
                    {
                        "vendorOrClientOrBUName": "Test Staffing Company",
                        "requisitionNumber": "REQ-20",
                        "roleName": "Senior Business Analyst",
                        "candidatesCount": 41,
                        "veryGood": 12,
                        "notApplicable": 7,
                        "veryPoor": 7,
                        "poor": 6,
                        "fair": 1,
                        "good": 3,
                        "excellent": 12,
                        "exceptional": 0,
                        "hired": 0,
                        "veryGoodCandidates": [
                            "5e0b46e180ee2253710f8e70",
                            "5ee651ab80ee226bec8694c1",
                            "5ee8d08580ee227378ccf882",
                            "5eea105c80ee2212ccc0ec58",
                            "5ee8b40a80ee227378ccf625",
                            "5eea101e80ee2212ccc0ec04",
                            "5ee8b45280ee227378ccf678",
                            "5e0b163d80ee2239fb213bdd",
                            "5e4e5a8380ee226d58fd1dbc",
                            "5e0b164280ee2239fb213c4b",
                            "5e132ed480ee22152c90d99d",
                            "5e0b164e80ee2239fb213d49"
                        ],
                        "veryPoorCandidates": [
                            "5d46d0d480ee22211325df6f",
                            "5cf3bf9380ee22651b4e18ed",
                            "5d6fb8dc80ee2232e70bb48b",
                            "5d76354780ee22093fc3d518",
                            "5d5bef5880ee226a36bb93f1",
                            "5d710e8b80ee2222b758e61a",
                            "5eef2d2280ee222e91ddddd5"
                        ],
                        "poorCandidates": [
                            "5e15c5b080ee22019883469f",
                            "5e1ae08f80ee221847695564",
                            "5ee2262280ee2235fc93b889",
                            "5d7634fe80ee22093fc3d510",
                            "5e181a8780ee2208f041a2d5",
                            "5d7a871380ee225f01269575"
                        ],
                        "fairCandidates": [
                            "5d68ba0680ee2254e8353d43"
                        ],
                        "goodCandidates": [
                            "5e0b46d480ee2253710f8d87",
                            "5ee22e0680ee2235fc93b95b",
                            "5e0b46de80ee2253710f8e32"
                        ],
                        "excellentCandidates": [
                            "5edec5c180ee2261734eb04b",
                            "5ee0c12780ee2244851645ad",
                            "5ee79cda80ee222c18370021",
                            "5f30d08a80ee2216f39a3cbe",
                            "5e0a0bcb80ee2253a2b3830c",
                            "5e0b195c80ee2239fb213eb1",
                            "5e8c9d8780ee222dc24ec193",
                            "5f5a303980ee225214c3f9b5",
                            "5e15dfcb80ee22143108bd8f",
                            "5e0b195a80ee2239fb213e75",
                            "5df7758080ee220b1480d065",
                            "5e0b164480ee2239fb213c83"
                        ],
                        "exceptionalCandidates": [],
                        "hiredCandidates": []
                    },
                    {
                        "vendorOrClientOrBUName": "Vendor Only Staffing Company",
                        "requisitionNumber": "REQ-20",
                        "roleName": "Senior Business Analyst",
                        "candidatesCount": 7,
                        "veryGood": 2,
                        "notApplicable": 1,
                        "veryPoor": 1,
                        "poor": 2,
                        "fair": 0,
                        "good": 0,
                        "excellent": 2,
                        "exceptional": 0,
                        "hired": 0,
                        "veryGoodCandidates": [
                            "5f1b30b980ee221b8e95e9ab",
                            "5ee2138680ee222a3b65d5ab"
                        ],
                        "veryPoorCandidates": [
                            "5d2dce7e80ee223b535ebbfe"
                        ],
                        "poorCandidates": [
                            "5d79dbbb80ee221ff653f14b",
                            "5e18647780ee226bd99bd420"
                        ],
                        "fairCandidates": [],
                        "goodCandidates": [],
                        "excellentCandidates": [
                            "5eec1fad80ee22778ca6d155",
                            "5e8c9ebd80ee222dc24ec227"
                        ],
                        "exceptionalCandidates": [],
                        "hiredCandidates": []
                    }
                ],
                "techAssessmentScoresReports": [
                    {
                        "vendorOrClientOrBUName": "Test Staffing Company",
                        "requisitionNumber": "REQ-20",
                        "roleName": "REQ-20",
                        "candidatesCount": 41,
                        "skipped": 0,
                        "beginner": 0,
                        "intermediate": 0,
                        "experienced": 0,
                        "proficient": 0,
                        "skippedCandidates": [],
                        "beginnerCandidates": [],
                        "intermediateCandidates": [],
                        "experiencedCandidates": [],
                        "proficientCandidates": []
                    },
                    {
                        "vendorOrClientOrBUName": "Vendor Only Staffing Company",
                        "requisitionNumber": "REQ-20",
                        "roleName": "REQ-20",
                        "candidatesCount": 7,
                        "skipped": 0,
                        "beginner": 1,
                        "intermediate": 0,
                        "experienced": 0,
                        "proficient": 0,
                        "skippedCandidates": [],
                        "beginnerCandidates": [
                            "5d2dce7e80ee223b535ebbfe"
                        ],
                        "intermediateCandidates": [],
                        "experiencedCandidates": [],
                        "proficientCandidates": []
                    }
                ],
                "releaseReasonsReports": [
                    {
                        "vendorOrClientOrBUName": "Test Staffing Company",
                        "requisitionNumber": "REQ-20",
                        "roleName": "REQ-20",
                        "candidatesCount": 41,
                        "releasedCandidates": 2,
                        "releaseReasons": {
                            "Not a good fit": 1,
                            "Lack of passion": 1
                        },
                        "candidatesWithReleasedReasons": {
                            "Not a good fit": [
                                "5ee79cda80ee222c18370021"
                            ],
                            "Lack of passion": [
                                "5e4e5a8380ee226d58fd1dbc"
                            ]
                        }
                    },
                    {
                        "vendorOrClientOrBUName": "Vendor Only Staffing Company",
                        "requisitionNumber": "REQ-20",
                        "roleName": "REQ-20",
                        "candidatesCount": 7,
                        "releasedCandidates": 0,
                        "releaseReasons": {},
                        "candidatesWithReleasedReasons": {}
                    }
                ],
                "notInterestedReasonsReports": [
                    {
                        "vendorOrClientOrBUName": "Test Staffing Company",
                        "requisitionNumber": "REQ-20",
                        "roleName": "REQ-20",
                        "candidatesCount": 41,
                        "notInterestedCandidates": 5,
                        "notInterestedReasons": {
                            "Not interested in the job requirement": 1,
                            "Other": 4
                        },
                        "candidatesWithnotInterestedReasons": {
                            "Not interested in the job requirement": [
                                "5d46d0d480ee22211325df6f"
                            ],
                            "Other": [
                                "5ee0c12780ee2244851645ad",
                                "5d76354780ee22093fc3d518",
                                "5ee22e0680ee2235fc93b95b",
                                "5d7a871380ee225f01269575"
                            ]
                        }
                    },
                    {
                        "vendorOrClientOrBUName": "Vendor Only Staffing Company",
                        "requisitionNumber": "REQ-20",
                        "roleName": "REQ-20",
                        "candidatesCount": 7,
                        "notInterestedCandidates": 1,
                        "notInterestedReasons": {
                            "Not interested in the job requirement": 1
                        },
                        "candidatesWithnotInterestedReasons": {
                            "Not interested in the job requirement": [
                                "5ee2138680ee222a3b65d5ab"
                            ]
                        }
                    }
                ]
            },
            "graphReport": {
                "vendorOrClientOrBUNames": [
                    "Vendor CN Test DONOT Delete",
                    "Pixtron_vendor",
                    "Test Staffing Company",
                    "Test Automation Staffing Company",
                    "Vendor Only Staffing Company"
                ],
                "workflowStepsGraphReport": {
                    "candidates": {
                        "Test Staffing Company": 41,
                        "Vendor Only Staffing Company": 7
                    },
                    "recruiterScreeningSkipped": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 3,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "recruiterScreeningDone": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "recruiterScreeningPassed": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "recruiterScreeningFailed": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "techAssessmentSkipped": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "techAssessmentDone": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "techAssessmentPassed": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "techAssessmentFailed": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "phoneScreenSkipped": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 1,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "phoneScreenScheduled": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "phoneScreenDone": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 4,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "phoneScreenPassed": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "phoneScreenFailed": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "interviewScheduled": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "interviewDone": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "interviewPassed": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 1,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "interviewFailed": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "hired": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "filled": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "released": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 2,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "notInterested": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 5,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 1
                    }
                },
                "jobMatchesScoresGraphReport": {
                    "notApplicable": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 7,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 1
                    },
                    "veryPoor": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 7,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 1
                    },
                    "poor": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 6,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 2
                    },
                    "fair": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 1,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "good": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 3,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "veryGood": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 12,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 2
                    },
                    "excellent": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 12,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 2
                    },
                    "exceptional": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 12,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 2
                    },
                    "hired": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    }
                },
                "techAssessmentScoreGraphReportDTO": {
                    "skipped": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "beginner": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 1
                    },
                    "intermediate": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "experienced": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    },
                    "proficient": {
                        "Vendor CN Test DONOT Delete": 0,
                        "Pixtron_vendor": 0,
                        "Test Staffing Company": 0,
                        "Test Automation Staffing Company": 0,
                        "Vendor Only Staffing Company": 0
                    }
                },
                "releaseReasons": [
                    {
                        "reason": "Weak recommendations",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Not interested in the company",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Moved by mistake",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Skill set mismatch to requirement",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Proctoring issue",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Co-workers didn’t approve",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Mismatch in salary expectations",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Not a good fit",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 1,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Administrative related",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Did not pass test",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Proctoring violation",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Overall poor presentation",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Didn’t answer questions clearly",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Lack of passion",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 1,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Not interested in the job requirement",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Not a right fit",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "No references to scenarios",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Story doesn't check out",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Term completed",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Not in the market right now",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Not responsive",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Performance related",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Added by mistake",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Interested in another offer",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Other",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    }
                ],
                "notInterestedReasons": [
                    {
                        "reason": "Weak recommendations",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Not interested in the company",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Moved by mistake",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Skill set mismatch to requirement",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Proctoring issue",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Co-workers didn’t approve",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Mismatch in salary expectations",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Not a good fit",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Administrative related",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Did not pass test",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Proctoring violation",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Overall poor presentation",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Didn’t answer questions clearly",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Lack of passion",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Not interested in the job requirement",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 1,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 1
                        }
                    },
                    {
                        "reason": "Not a right fit",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "No references to scenarios",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Story doesn't check out",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Term completed",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Not in the market right now",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Not responsive",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Performance related",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Added by mistake",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Interested in another offer",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 0,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    },
                    {
                        "reason": "Other",
                        "counts": {
                            "Vendor CN Test DONOT Delete": 0,
                            "Pixtron_vendor": 0,
                            "Test Staffing Company": 4,
                            "Test Automation Staffing Company": 0,
                            "Vendor Only Staffing Company": 0
                        }
                    }
                ]
            }
        };
    }
}
function setStyle(element, propertyObject) {
    for (var property in propertyObject) {
        element.style[property] = propertyObject[property];
    }
}
function CustomPinnedRowRenderer() { }
CustomPinnedRowRenderer.prototype.init = function (params) {
    this.eGui = document.createElement('div');
    setStyle(this.eGui, params.style);
    this.eGui.innerHTML = params.value;
};
CustomPinnedRowRenderer.prototype.getGui = function () {
    return this.eGui;
};
//# sourceMappingURL=requisition-performance-report.service.js.map